<div class="desktop-full-screen-overlay--flex">
  <div class="deposit-form-container">
    <app-form-container
      [title]="'webPos.Deposit' | translate"
      (onCancel)="close()"
      (onSubmit)="createFinancialTransaction()"
      [confirmDisabled]="isSubmitDisabled"
    >
      <ng-container form-body>
        <form [formGroup]="form" class="deposit-form">
          <app-dropdown
            [label]="'webPos.ValuableType' | translate"
            [options]="valuableTypeOptions"
            formControlName="valuableType">
          </app-dropdown>

          @if (hasNominals) {
          <div [formGroup]="form.controls.denominationRowsGroup" class="nominals-container">
            <div formArrayName="rows" id="depositDenominationRows" class="deposit-form__row-container">
              <div *ngFor="let rowCtrl of rows.controls; let i = index" class="deposit-form__row" [formGroupName]="i">
                <div class="deposit-form__row-counter">
                  <span>{{ i + 1 }}.</span>
                </div>

                <app-dropdown
                  class="deposit-form__row-value"
                  [label]="'webPos.Value' | translate"
                  [options]="nominalOptions"
                  formControlName="value">
                </app-dropdown>

                <app-form-input
                  class="deposit-form__row-pieces"
                  [label]="'webPos.CountOfPieces' | translate"
                  [type]="FormInputType.Number"
                  formControlName="numberOfItems">
                </app-form-input>

                <div class="deposit-form__row-add-button">
                  <fa-icon [icon]="['fas', 'circle-plus']" (click)="addRow()"></fa-icon>
                </div>
                <div class="deposit-form__row-delete-button" [class.deposit-form__row-delete-button--disabled]="rows.length <= 1">
                  <fa-icon [icon]="['fas', 'trash']" (click)="removeRow(i)"></fa-icon>
                </div>
              </div>
            </div>

            <div class="deposit-form__total">
              <span>{{ 'webPos.Closings.TotalValue' | translate }}:</span>
              <span>{{ totalNominalValue | number }} {{ selectedPaymentType?.Currency || loginService.user.CurrencyCode | currencymap }}</span>
            </div>
          </div>
          } @else {
          <app-form-input
            [label]="'webPos.Value' | translate"
            [placeholder]=""
            [type]="FormInputType.Number"
            [value]=""
            formControlName="value">
          </app-form-input>
          }

          <app-dropdown
            [label]="'webPos.Reason' | translate"
            [options]="reasonOptions"
            [value]=""
            formControlName="reason">
          </app-dropdown>

          <app-form-textarea
            [label]="'webPos.Note' | translate"
            formControlName="note">
          </app-form-textarea>
        </form>
      </ng-container>
    </app-form-container>
  </div>
</div>
